import React, { useEffect, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { encodeBase64Fake, getRemotedbUrl, i18nIntl, isNotEmpty } from '../../lib/ep';
import { useFilterDataQuery, usePaginator } from '../FilterContent';

import { SecondaryButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection';
import FloatingLayer from '../builder/FloatingLayer';
import SaveButton from '../builder/SaveButton';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle, { SectionTitleWithButtons } from '../builder/SectionTitle';
import Spinner from '../builder/Spinner';
import Tooltip from '../builder/Tooltip';

import Paginator from '../utils/Paginator';

const VoteLogs = ({ ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stage = props?.stage ?? false;
	const promotion = props?.promotion ?? false;
	const participation = props?.participation ?? false;
	const display_blocked = props?.display_blocked ?? false;
	const fraud_points = props?.fraud_points ?? 0;
	const [confirm_delete_fraudulents, setConfirmDeleteFraudulents] = useState(false);
	const [loading, setLoading] = useState(false);

	let getVoteLogs;
	if(display_blocked) {
		 getVoteLogs = (start = false, limit = 100) => {
			return $.getJSON(getRemotedbUrl(`/stages/getfraudvotelogs/${promotion.id}/${stage.id}/${participation.id}`), { start, limit }, (res) => {
				setLoading(false);
			});
		};
	} else {
		 getVoteLogs = (start = false, limit = 100) => {
			return $.getJSON(getRemotedbUrl(`/stages/getvotelogs/${promotion.id}/${stage.id}/${participation.id}`), { start, limit }, (res) => {
				setLoading(false);
			});
		};
	}

	const [ state, dispatch, fetchAll,refetch ] = useFilterDataQuery(`vote_logs${participation.id}`, getVoteLogs);
	const [ vote_logs, pagination, goToPage ] = usePaginator(state.filtered, 100);

	useEffect(()=>{
		setLoading(true);
		refetch();
	},[display_blocked,participation])

	const confirmDelete = (cb) => {
		const send_info = {stage_id:stage.id,candidate_id:participation.id}
		$.post({
			url:getRemotedbUrl(`/stages/delete_fraudulent_votes/${promotion.id}`),
			data:{
				_data:encodeBase64Fake(send_info),
			},
			dataType:'JSON',
			success:(response) => {
				if(cb != undefined) cb();
				if(props.close != undefined)props.close();
			}
		});
	}

	return (
		<div class="without_actions">
			<SectionTitleWithButtons
				autotranslate={false}
				actions={(display_blocked) ? <SecondaryButton disabled={loading} onClick={() => setConfirmDeleteFraudulents(true)}>Delete all</SecondaryButton> : null}
			>
				{(display_blocked) ? (
					<FormattedMessage id="Fraudulent votes for {user}" values={{user:`${participation.name}: ${fraud_points}`}} />
				): (
					<FormattedMessage id="Vote logs for {user}" values={{user:participation.name}} />
				)}
			</SectionTitleWithButtons>

			<table class="gui_list_table" width="100%" cellPadding="0" cellSpacing="0">
				<thead>
					<tr class="list_header">
						<th>{i18n("Voter name")}</th>

						<th class="gui_text_align_end" width="10%">{i18n("points", 'ucfirst')}</th>

						<th class="gui_text_align_center" width="20%">{i18n("Date")}</th>

						<th class="gui_text_align_end" width="30%">{i18n("Origin")}</th>
					</tr>
				</thead>

				<tbody>
					{!loading && vote_logs.map((vote_log) => {
						return (
							<tr key={vote_log.StageVoteLog.id}>
								<td>
									<div class="gui_flexbox_auto gui_flex_col">
										<ActionLink
											onClick={() => props.open_info_layer(vote_log.Participation.login_id)}
											autotranslate={false}
										><strong>{vote_log?.Participation?.name ?? "No name"}</strong></ActionLink>

										{(isNotEmpty(vote_log.Participation, 'email')) && (
											<span>&gt; {vote_log.Participation.email}</span>
										)}
									</div>
								</td>

								<td class="gui_text_align_end">{vote_log.StageVoteLog.points}</td>

								<td class="gui_text_align_center">
									{(isNotEmpty((vote_log?.Participation ?? {}), 'created')) ? (
										EPDateFromNow(vote_log.Participation.created)
									) : (
										<span>-</span>
									)}
								</td>

								<td class="gui_text_align_end">
									<div class="sided_contents">
										{(isNotEmpty((vote_log?.Participation ?? {}), 'ip')) && (
											<span style={{flexGrow:'1'}}>{vote_log.Participation.ip}</span>
										)}

										{(isNotEmpty((vote_log?.Participation ?? {}), 'device')) && (
											<Tooltip
												position="top"
												icon={`knk-${vote_log.Participation.device}`}
											>{vote_log.Participation.device_label}</Tooltip>
										)}

										{(isNotEmpty((vote_log?.Participation ?? {}), 'browser')) && (
											<Tooltip
												position="top"
												icon={`knk-${vote_log.Participation.browser}`}
											>{vote_log.Participation.browser_label}</Tooltip>
										)}
									</div>
								</td>
							</tr>
						)
					})}
					{(loading) && (
						<tr>
							<td colSpan={4} class="gui_pos_rel">
								<article class="entries_list" style={{minHeight:'100px'}}>
									<Spinner autotranslate={false}>{i18n("Loading")}...</Spinner>
								</article>
							</td>
						</tr>
					)}
				</tbody>
			</table>

			{(pagination.total_pages > 1) && (
				<Paginator
					{...pagination}
					goToPage={goToPage}
				/>
			)}

			{(confirm_delete_fraudulents) && (
				<FloatingLayer
					backButton={() => setConfirmDeleteFraudulents(false)}
					_class={{ size:'small' }}
				>
					<div>
						<SectionTitle>Are you sure you want to delete all fraudulent votes?</SectionTitle>
						<SectionSubtitle>Deleting them will update the vote counter.</SectionSubtitle>
						<ButtonCollection in_floating={true}>
							<SaveButton
								onClick={(e,cb) => confirmDelete(cb)}
							>Confirm</SaveButton>

							<SecondaryButton
								onClick={() => setConfirmDeleteFraudulents(false)}
							>Cancel</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</div>
	)
};

export default injectIntl(VoteLogs);